import TextFieldInput from './TextFieldInput';

export default TextFieldInput.withComponent('textarea');



// WEBPACK FOOTER //
// ./src/components/TextField/private/TextFieldMultilineInput.tsx